import React, { useRef } from "react";
import clsx from "clsx";
import { Button, Form, TextField } from "@curves/ui-base";
import GradientColorHeader from "@icoach/components/dialog/GradientColorHeader";
import { Dialog, DialogActions, DialogContent, Grid } from "@mui/material";
import { useMemberProfileApi } from "@apis/useMemberProfileApi";
import { isFunction, refIsRequiredError } from "@util/utils";
import { MEMBER_NOTE_TYPE } from "@icoach/constants/";

const SpecialConditionDialog = React.forwardRef((props, ref) => {
	const { open, className, sourceData, onClose, refresh } = props;
    if (!open) return null;
	const { memberID, specialCondition } = sourceData || {};
	const { postMemberProfileNotesApi } = useMemberProfileApi();

	const specialConditionRef = useRef();

	const doMemberProfileNotesApi = async (memberID, params) => {
		let resp = await postMemberProfileNotesApi(memberID, params);
		if (resp) {
			const { notes } = resp;
			isFunction(refresh) && refresh(notes);
			isFunction(onClose) && onClose();
		}
	};

	const handleSubmit = () => {
		if (!refIsRequiredError(specialConditionRef)) {
			let params = {
				noteType: MEMBER_NOTE_TYPE.SPECIALCONDITION,
				notes: specialConditionRef.current && specialConditionRef.current.getResult(),
			};
			doMemberProfileNotesApi(memberID, params);
		}
	};
	return (
		<Dialog className={clsx("simple-content", "dialog", className)} PaperProps={{ className: "wx-65rem", component: Form }} onSubmit={handleSubmit} open={open} fullWidth>
			<GradientColorHeader onClose={onClose}>聯繫注意與偏好</GradientColorHeader>
			<DialogContent>
				<Grid container spacing={3}>
					<Grid item xs={12}>
						<TextField
							label="聯繫注意與偏好"
							ref={specialConditionRef}
							key={specialCondition}
							defaultValue={specialCondition}
							InputProps={{ placeholder: "請輸入" }}
							rows="4"
							multiline
							fullWidth
						/>
					</Grid>
				</Grid>
			</DialogContent>
			<DialogActions>
				<Button type={"submit"} variant="contained">
					確認送出
				</Button>
			</DialogActions>
		</Dialog>
	);
});

export default SpecialConditionDialog;
